export class Translation {

    private code: string;
    private text: string;

    constructor(raw: any) {
        if (raw) {
            this.setCode(raw.TEXT_CODE);
            this.setText(raw.TEXT);
        }
    }

    public getCode(): string {
        return this.code;
    }

    public setCode(code: string): void {
        this.code = code;
    }

    public getText(): string {
        return this.text;
    }

    public setText(text: string): void {
        this.text = text;
    }

}